import { all, fork, put, takeLatest } from "redux-saga/effects";
import actions from "../actions";
import CONSTANTS from "../CONSTANTS";

const baseUrlCmm = "/services/rcp/profile/common/";

export function* getMainIsOutOfOffice() {
  yield takeLatest(CONSTANTS.GET_MAIN_IS_OUT_OF_OFFICE, function* (action) {
    try {
      yield put(actions.setMainIsOutOfOffice(false));

      const url = baseUrlCmm + "IsOutOfOffice";
      const res = yield window.mainAxios.get(url).then((x) => x.data);
      if (res?.success) {
        localStorage.setItem("isOutOfOffice", res?.data);
      }
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };

      yield put(actions.setMainIsOutOfOffice(res?.data));
    } catch (e) {
      yield put(actions.setMainIsOutOfOffice(false));
    }
  });
}
export function* getTechnicalMessages() {
  yield takeLatest(CONSTANTS.GET_MAIN_TECHICAL_MESSAGE, function* (action) {
    try {
      yield put(actions.setTechnicalMessages(null));

      const url = baseUrlCmm + "GetTechnicalMessages";
      const res = yield window.mainAxios.get(url).then((r) => r.data);
      // console.log(res)
      // eslint-disable-next-line no-throw-literal
      if (!res.success)
        throw {
          errorCode: res.errorCode,
          errorMessage: res.errorMessage,
        };
      yield put(actions.setTechnicalMessages(res));
    } catch (e) {
      yield put(actions.setTechnicalMessages(null));
      console.error(e);
    }
  });
}
export default function* profileCommonSaga() {
  yield all([fork(getMainIsOutOfOffice), fork(getTechnicalMessages)]);
}
